module.exports = __webpack_public_path__ + "static/img/freight-platform_256.3c327c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freight-platform_256.png
// module id = j1q/
// module chunks = 0